var i = Object.defineProperty,
  t = Object.getOwnPropertySymbols,
  l = Object.prototype.hasOwnProperty,
  c = Object.prototype.propertyIsEnumerable,
  a = (o, e, r) => e in o ? i(o, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : o[e] = r,
  p = (o, e) => {
    for (var r in e || (e = {})) l.call(e, r) && a(o, r, e[r]);
    if (t) for (var r of t(e)) c.call(e, r) && a(o, r, e[r]);
    return o;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const u = () => typeof window == "undefined",
  _ = () => typeof window == "undefined" ? !1 : !!window.Lurker,
  w = _ref => {
    let {
      eventType: o,
      objectDetail: e,
      objectName: r,
      data: d
    } = _ref;
    if (u()) return;
    const n = p({
      event_type: o,
      object_detail: e,
      object_name: r
    }, d);
    if (!_()) {
      console.groupCollapsed("[Lurker][debug][".concat(o, "][").concat(e, "]")), console.log(n), console.groupEnd();
      return;
    }
    window.Lurker.sendBeacon(n, !0);
  };
export { w as sendToLurker };